import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as MDICONS from '@material-ui/icons';

class GeneralNotification extends Component {
    render() {
        const { notifUtils, notificationItem, modalStyles,
            modalTitleStyle, formLabelStyle, modalWidth,
        } = this.props;

        const { notificationIcon } = notifUtils;

        const { notify, requestCode, timestamp } = notificationItem;
        const momentFromNow = moment(timestamp.toDate()).fromNow();
        const notifIcon = notificationIcon[requestCode];


        return (
            <div className="dynamicModalContainerSm">
                <div className="dynamicModalSm">
                    <h5 style={modalTitleStyle}>Notification details:</h5>
                    <br />
                    <p><span style={{ color: "gray" }}>{notifIcon} <MDICONS.MoreVert /> </span>{notify}<span className="float-right" style={{ color: "gray", fontStyle: "italic" }}><MDICONS.Remove /> {momentFromNow}</span></p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        themeColors: state.theme,
        userData: state.firebase.profile,
        notifUtils: state.notifUtils,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
    }
}

export default connect(mapStateToProps)(GeneralNotification);